import { Component, Vue, Watch} from 'vue-property-decorator';
import DataTable, { TableVisibility } from '@/components/data-table/DataTable';
import { Options } from '@/components/mi-dialog/MiDialog';
import { AxiosError } from 'axios';
import ErrorHandler from '@/support/ErrorHandler';
import CreateDialog from '@/views/Settings/Tags/CreateDialog';
import { Tag } from '@/models/Tag';

@Component<Tags>({
  components: {
    CreateDialog,
  },
})
export default class Tags extends Vue {

  protected selectedTag: Tag | null = null;
  protected isCreatingTag: boolean = false;

  protected visibility: TableVisibility = {
    title: false,
    checkboxes: false,
    search: true,
  }

  protected mounted() {}

  get tableOptions(): Object {
    return {
      model: new Tag(),
      name: {
        singular: 'Tag',
        plural: 'Tags',
      },
      sort: {
        key: 'name',
        order: 'ASC',
      },
      headers: [
        {
          text: 'Name',
          value: 'name',
          sortable: {
            key: 'name',
            order: 'ASC',
          },
        },
      ],
      actions: [
        {
          type: 'edit',
          label: 'edit',
          icon: 'edit',
          action: (datatable: DataTable, tag: Tag) => {
            this.selectedTag = tag;
            this.isCreatingTag = true;
          },
        },
        {
          type: 'delete',
          label: 'delete',
          icon: 'delete',
          action: (datatable: DataTable, tag: Tag) => {
            this.selectedTag = tag;
            this.$store.dispatch('openDialog', this.dialogOptions);
          },
        },
      ],
      add: () => {
        this.isCreatingTag = true;
      }
    };
  }

  protected get tagsDatatable(): DataTable|null {
    const dataTable = this.$refs.tagsDatatable;
    if(dataTable) {
      return (dataTable as DataTable);
    }

    return null;
  }

  get dialogOptions(): Options {
    return {
      title: (this.selectedTag as Tag).name || 'Confirm deletion',
      text: 'Are you sure you wish to delete this tag?',
      type: 'warning',
      buttons: {
        confirm: {
          text: 'Delete',
          action: () => {
            if (!this.selectedTag) {
              return;
            }

            this.selectedTag
              .delete()
              .then((response: any) => {
                if (response) {
                  this.tagsDatatable ? this.tagsDatatable.refresh(true) : null;
                  this.selectedTag = null;
                }
              })
              .catch((error: AxiosError) => {
                ErrorHandler.network(error);
              });
          },
        },
        cancel: {
          text: 'Cancel',
          action: () => {
            this.selectedTag = null;
          },
        },
      },
    };
  }

  @Watch('isCreatingTag')
  protected isCreatingTagChanged() {
    if(!this.isCreatingTag) {
      this.selectedTag = null;
    }
  }
}
